import { useCallback } from 'react';
import { ICreateUserAccountFormData } from '../types/ICreateUserAccountFormData';
import { useSignUp } from '../../../../../auth/sign-up/ui/helpers/useSignUp';
import { useSaveBookingOnSignUpSuccess } from './useSaveBookingOnSignUpSuccess';
import { useNewBookingStore } from '../../../../domain/booking/stores/useNewBookingsStore';

export function useCreateUserAccountSubmit() {
	const newBookingStore = useNewBookingStore();

	const { error, success, submit: signUp } = useSignUp();

	const submit = useCallback(
		async ({ password }: ICreateUserAccountFormData) => {
			const { personalDetails, vehicleDetails } = newBookingStore.booking;

			if (!personalDetails || !vehicleDetails) {
				throw new Error('Invalid booking details');
			}

			const { firstName, lastName, email } = personalDetails;
			const { licensePlateNumber } = vehicleDetails;

			await signUp({
				firstName,
				lastName,
				email,
				password,
				licensePlateNumber,
			});
		},
		[signUp, newBookingStore],
	);

	useSaveBookingOnSignUpSuccess(success);

	return { submit, error, success };
}
